import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state
export interface sessionParticipantContactsTableStateState {
    TableState: string;
}

// Define the initial state using that type
const initialState: sessionParticipantContactsTableStateState = {
    TableState: JSON.stringify({
        sorting: {
            sortModel: [{ field: "name", sort: "asc" }],
        },
        columns: {
            columnVisibilityModel: {
                attendance: true,
                registrationStatus: true,
                name: true,
                firstName: false,
                lastName: false,
                emailAddress: true,
                telephone: true,
                organization: true,
                title: true,
                city: true,
                state: true,
                country: true,
                postalCode: true,
            },
        },
    }),
};

export const sessionParticipantContactsTableStateSlice = createSlice({
    name: "sessionParticipantContactsTableState",
    initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        updateSessionsParticipantContactsGridState: (
            state,
            action: PayloadAction<string | null>
        ) => {
            state.TableState = action?.payload ?? initialState.TableState;
        },
    },
});

export const { updateSessionsParticipantContactsGridState } =
    sessionParticipantContactsTableStateSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const sessionParticipantContactsTableState = (state: RootState) => state;
export default sessionParticipantContactsTableStateSlice.reducer;
